'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
type NavigationProgressContextValue = {
  active: boolean;
  begin: () => void;
  end: () => void;
};
const NavigationProgressContext = createContext<NavigationProgressContextValue>({
  active: false,
  begin: () => {},
  end: () => {}
});
export const NavigationProgressProvider = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [count, setCount] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setCount(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const begin = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setCount(_temp2);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const end = t2;
  const t3 = count > 0;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      active: t3,
      begin,
      end
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const value = t4;
  let t5;
  if ($[4] !== children || $[5] !== value) {
    t5 = <NavigationProgressContext.Provider value={value}>{children}</NavigationProgressContext.Provider>;
    $[4] = children;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export const useNavigationProgress = () => {
  return useContext(NavigationProgressContext);
};
function _temp(c) {
  return c + 1;
}
function _temp2(c_0) {
  return Math.max(0, c_0 - 1);
}